import React from 'react'
import { styled } from '@mui/system'
import ColumnFilterButton from './ColumnFilterButton'

const RootContainer = styled('div')({
  minWidth: 'fit-content',
})

type Props = {
  options: { label: string; value: any; icon?: JSX.Element }[]
  onChange: (value: any) => void
  disabled?: boolean
  selectedValue?: any
}

export const ColumnFilterButtonGroup = (props: Props) => {
  const { options, selectedValue, onChange } = props
  return (
    <RootContainer>
      {options.map((u, i) => (
        <ColumnFilterButton
          key={i}
          title={u.label}
          onClick={() => onChange(u.value)}
          isSelected={u.value === selectedValue}
        />
      ))}
    </RootContainer>
  )
}
